import React from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {Field, useFormikContext} from 'formik'
import {Product} from '../../../../core/_models'
import {CustomSelect} from '@/components/form/CustomSelect'

type Props = {
  statuses: string[]
}

const StatusCard: React.FC<Props> = ({statuses}) => {
  const intl = useIntl()
  const { values } = useFormikContext();
  const product = values as Product

  return (
    <div className="card card-flush py-4">
      <div className="card-header">
        <div className="card-title">
          <h2>Status</h2>
        </div>
        <div className="card-toolbar">
          <div className={clsx("rounded-circle w-15px h-15px", {
            'bg-success': product.status === 'PUBLISHED',
            'bg-primary': product.status === 'DRAFT',
            'bg-danger': product.status === 'DISABLED'
          })}/>
        </div>
      </div>
      <div className="card-body pt-0">
        <Field
          component={CustomSelect}
          options={statuses.map((s: string) => ({
            value: s, label: intl.formatMessage({id: `P2C.PRODUCT_STATUS_${s}`})
          }))}
          name="status"
          id="status"
          required={true}
        />
        <div className="text-muted fs-7">Set the product status.</div>
      </div>
    </div>
  )
}

export {StatusCard}
